import { createContext, useState } from 'react';
import { createStore } from 'jotai';

const Store = createStore();
type MobilePOSType = {
  causeId: string;
} & typeof Store;
const MobilePOSContext = createContext<MobilePOSType | undefined>(undefined);

const MobilePOSProvider = ({
  children,
  causeId,
}: {
  causeId: string;
  children: React.ReactNode;
}) => {
  const [store] = useState(() => createStore());
  return (
    <MobilePOSContext.Provider value={{ ...store, causeId }}>{children}</MobilePOSContext.Provider>
  );
};

export { MobilePOSContext, MobilePOSProvider };
